import React from "react";

import { InfoCircleOutlined } from "@ant-design/icons";
import {
  Input,
  Select,
} from "antd";

import {
  getSearchableSelectProps,
  renderSelectPopupScrollbar,
  selectPopupClassNames,
  selectSearchSuffixIcon,
} from "../../Common/UIComponents/SelectPopupScrollbar";
import StyledTooltip from "../../Common/UIComponents/StyledTooltip";

import "./AddMemberModalInput.css";

export default function AddMemberModalInput({
  value,
  label,
  field,
  placeholder,
  onChange,
  handleOnBlur,
  innerRef,
  disabled,
  suffix,
  useDropdown,
  dropdownOptions,
  tooltipTitle,
}) {
  const onBlur = () => {
    if (handleOnBlur) {
      handleOnBlur(value);
    }
  };

  const handleOnChange = (e) => {
    let input_value = e.target ? e.target.value : e;
    if (field === "email") {
      input_value = input_value.split("@")[0];
    }
    if (onChange) {
      onChange(input_value);
    }
  };

  return (
    <div className="AddMemberModal__InputParent">
      <div className="myAccountFormTitle">
        {label}
        {tooltipTitle && (
          <StyledTooltip
            title={tooltipTitle}
            placement="top"
            className="TeamMember__Tooltip"
          >
            <InfoCircleOutlined
              className="AddMemberModal__RoleInfo"
              aria-label="More information"
            />
          </StyledTooltip>
        )}
      </div>
      {!useDropdown && (
      <Input
        ref={innerRef}
        className={`${field === "email" ? "AddMemberModalInput AddMemberModalInput--email" : "AddMemberModalInput"} ${disabled ? "AddMemberModalInput--disabled" : ""}`}
        value={value}
        disabled={disabled}
        onChange={handleOnChange}
        placeholder={placeholder}
        onBlur={onBlur}
        addonAfter={suffix}
      />
      )}
      {useDropdown && (
      <Select
        value={value}
        disabled={disabled}
        className="AddMemberModalSelect"
        {...getSearchableSelectProps()} // eslint-disable-line react/jsx-props-no-spreading
        /* Keep ↓ after spread — AntD otherwise swaps to trailing search while open */
        suffixIcon={selectSearchSuffixIcon}
        classNames={selectPopupClassNames("AddMemberModalSelect__Dropdown")}
        virtual={false}
        listHeight={256}
        popupRender={(menu) => renderSelectPopupScrollbar(menu, {
          optionCount: (dropdownOptions || []).length,
        })}
        options={dropdownOptions}
        onChange={handleOnChange}
        placeholder={placeholder}
        onBlur={onBlur}
      />
      )}
    </div>
  );
}
